// extracted by mini-css-extract-plugin
module.exports = {"icon":"style_icon__2nRa9","avatar":"style_avatar__3dQuS"};